import React, { useEffect, useState } from "react";
import { Container, Box, Grid } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import WeatherWidget from "../../components/WeatherWidget";
import QuickLinks from "../../components/QuickLinks";
import NewsSection from "../../components/AlertsUpdates";
import getQuickLinks from "../../Data/iconsData";
import TickerTape from "../../components/Custom/CustomTickertape";
import CustomDashboardCard from "../../components/Custom/CustomDashboard";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../globals/axios";

export default function BuyerHomepage() {
  const quickLinksData = getQuickLinks("buyer");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [profileComplete, setProfileComplete] = useState(false);
  const [alerts, setAlerts] = useState([]);

  const fetchBuyerDetails = async () => {
    try {
      const result = await api.get(`/buyer/buyerdetails/`);
      console.log("Buyer details:", result.data);
      setProfileComplete(true);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        navigate("/buyer/details/");
      } else {
        console.error("Error fetching buyer details:", error);
      }
    }
  };

  const fetchAlertUpdates = async () => {
    try {
      const response = await api.get("/common/alert-updates/");
      setAlerts(response.data);
    } catch (error) {
      console.log("Error Fetching Tutorials list:", error);
    }
  };

  useEffect(() => {
    fetchBuyerDetails();
    fetchAlertUpdates();
  }, []);

  return (
    <>
      {profileComplete && (
        <div>
          <CustomAppBar />
          <Container maxWidth="xs" style={{ marginTop: 20 }}>
            <WeatherWidget />
            <TickerTape />
            <Box sx={{ marginTop: "20px" }}>
              <Grid container spacing={0.5}>
                <Grid item xs={6}>
                  <CustomDashboardCard title={t("FARMERS")} data={131} />
                </Grid>
                <Grid item xs={6}>
                  <CustomDashboardCard title={t("COMMODITIES")} data={87} />
                </Grid>
              </Grid>
            </Box>
            <QuickLinks data={quickLinksData} />
          </Container>
          <Container
            maxWidth="xs"
            sx={{ marginBottom: "60px", padding: "0px" }}
          >
            <NewsSection news images={alerts} />
          </Container>
        </div>
      )}
    </>
  );
}
